import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Divider } from 'antd';
import style from './index.less';

const MessageTranslate = props => {
  const { translateData } = props;
  return translateData.fail ? null : (
    <div className={style.translate_wrap}>
      <Divider className={style.translate_divider} />
      {translateData.translating ? <LoadingOutlined className={style.translate_icon} /> : null}
      {translateData.translated}
    </div>
  );
};

export default MessageTranslate;
